import React from 'react'
import { Search, DatePicker } from 'components/common'
import editProfile from './edit-profile'

class ConnectTrainee extends React.Component {
	constructor(props) {
		super(props)
		this.state = {
			user: null,
			search: null,
			company_entity_associated_mode: 0
		}
	}

	componentDidMount() {
		if (this.props.autoSearch) {
			this.doSearch(this.props.autoSearch);
		}
	}

	componentDidUpdate(prevProps) {
		if (this.props.autoSearch && this.props.autoSearch !== prevProps.autoSearch) {
			this.doSearch(this.props.autoSearch);
		}
	}

	doSearch = (value) => {
		http.post('/entities/find_by_doc.json', {
			term: value
		}, (response, success) => {
			if (response) {
				hp.store.evt_start_is_visible = response.evt_start_is_visible
				this.setState({
					user: response.user,
					search: value,
					company_entity_associated_mode: response.company_entity_associated_mode
				})
			}
		})
	}

	onAssoc = () => {
		const {user, company_entity_associated_mode} = this.state

		if(this.props.onAssociate) {
			this.props.onAssociate(user);
			return;
		}
		
		http.post('/companies/add_entity.json', {
			user_id: user.user_id,
			validated: company_entity_associated_mode == 0 ? 1 : 0,
			evt_start: user.evt_start || null
		}, (response, success) => {
			if (!success) {
				return
			}

			this.forceUpdate()
		})
	}

	render() {
		const {user, company_entity_associated_mode} = this.state
		let _user = null

		if (user != null) {
			let actions;

			if (user.my_employee == 1) {
				actions = <div className="alert-none">Este utilizador está associado à minha empresa</div>
			}
			else {
				actions = user.my_employee == -1
					? <div className="alert-none">Já foi enviado um email ao utilizador a solicitar a associação</div>
					: null
				actions =
					<div>
						{actions}
						<div className="pull-right btn-group">
							{company_entity_associated_mode == 0
							? <button className="btn btn-primary" onClick={this.onAssoc}>
								<em className="la la-check" />
								<span>Associar utilizador</span>
								</button>
							: <button
								className="btn btn-primary"
								title="envia pedido de associação ao utilizador"
								onClick={this.onAssoc}
								>
								<em className="la la-at" />
								<span>Enviar pedido de associação</span>
							</button>}
						</div>
					</div>
			}
			_user =
				<div className="container-fluid pcontent">
					<div className="row">
						<div className="col-xs-12 col-xs-4">
							<img src={user.photo || null} alt={user.name} style={{width:'100%'}} />
						</div>
						<div className="col-xs-12 col-xs-8">
							<table className="table alternate">
								<tbody>
									<tr>
										<td><label>{__('attrs_name')}</label></td>
										<td>{user.name}</td>
									</tr>
									<tr>
										<td><label>{__('attrs_id_doc_num')}</label></td>
										<td>{user.doc}</td>
									</tr>
									<tr>
										<td><label>{__('attrs_nif')}</label></td>
										<td>{user.nif}</td>
									</tr>
									<tr>
										<td><label>{__('attrs_email')}</label></td>
										<td>{user.email}</td>
									</tr>
									<tr>
										<td><label>{__('attrs_phone')}</label></td>
										<td>{user.phone}</td>
									</tr>
									<tr>
										<td><label>{__('attrs_birth')}</label></td>
										<td>{user.birth}</td>
									</tr>
									{ hp.store.evt_start_is_visible ?
										<tr>
											<td><label>{__('attrs_company_evt_start')}</label></td>
											<td><DatePicker model={user} name="evt_start" /></td>
										</tr>
									 	: null
									}
									<tr>
										<td colSpan="2">
											{actions}
										</td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
				</div>
		}
		return (
			<div className="pcontent">
				<label>{__('companies_associate_user_label')}</label>
				<div className="hp-input-max-200">
					<Search name="term"
						placeholder={__('companies_associate_user_label')}
						className="prompt form-control"
						timeout={0}
						showSearchButton={true}
						doSearch={this.doSearch}
					/>
				</div>
				{_user}
			</div>
		)
	}
}

export default ({ canCreateNewUser = false, onAssociate, fromLeadership = false }) => {
	const buttons = ['close'];

	if (canCreateNewUser) {
		buttons.unshift({
			icon: 'la la-user-plus',
			text: 'Novo colaborador',
			onClick: () => {
				mbox.dismiss()
				editProfile({user_id: 0, name: 'Novo colaborador', fromLeadership},
					(user) => {
						if(user.nif || user.doc_id) {
							mbox.modal(<ConnectTrainee onAssociate={onAssociate} autoSearch={user.nif ?? user.doc_id} />, {
								title: __('companies_add_trainee'),
								buttons: ['close']
							});
						}
					}
				)
			}
		})
	}

	mbox.modal(<ConnectTrainee onAssociate={onAssociate} fromLeadership={fromLeadership} />, {
		title: __('companies_add_trainee'),
		buttons
	});
}
